import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

export const Route = createFileRoute(
	"/$workspaceId/projects/$channelId/boards",
)({
	component: BoardsPage,
});

function BoardsPage() {
	return <div>Boards Page</div>;
}
